(() => {
  const init = (root) => {
    const input = root.querySelector('[data-collection-search]');
    const buttons = [...root.querySelectorAll('[data-player-filter]')];
    const countEl = root.querySelector('[data-visible-count]');
    const empty = root.querySelector('[data-collection-empty]');
    const status = root.querySelector('[data-collection-status]');
    const grid = root.querySelector('[data-collection-grid]');
    const pagination = root.querySelector('.pagination');
    if (!grid) return;

    const totalPages = parseInt(grid.dataset.totalPages, 10) || 1;
    const totalCount = parseInt(grid.dataset.totalCount, 10) || 0;
    const baseUrl = grid.dataset.collectionUrl || window.location.pathname;
    const pageItems = [...grid.querySelectorAll('[data-product-item]')];
    const extraItems = [];
    let everything = pageItems;
    const requestedPlayer = new URLSearchParams(window.location.search).get('player');
    let player = ['1', '2', '4'].includes(requestedPlayer) ? requestedPlayer : '';
    let loadPromise = null;

    const hasSearch = () => Boolean(input && input.value.trim());
    const hasFilter = () => Boolean(hasSearch() || player);

    const setActiveButton = () => {
      buttons.forEach((button) => {
        const active = button.dataset.playerFilter === player;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };

    const syncPlayerToUrl = () => {
      const url = new URL(window.location.href);
      if (player) url.searchParams.set('player', player);
      else url.searchParams.delete('player');
      window.history.replaceState({}, '', url);
      syncPaginationLinks();
    };

    const syncPaginationLinks = () => {
      if (!pagination) return;
      pagination.querySelectorAll('a[href]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        if (player) url.searchParams.set('player', player);
        else url.searchParams.delete('player');
        link.href = url.toString();
      });
    };

    const render = () => {
      if (!hasFilter()) {
        extraItems.forEach((element) => element.remove());
        everything = pageItems;
        pageItems.forEach((element) => { element.hidden = false; });
        if (countEl) countEl.textContent = totalCount;
        if (empty) empty.hidden = true;
        if (pagination) pagination.hidden = false;
        return;
      }

      if (hasSearch()) {
        if (pagination) pagination.hidden = true;
      } else {
        extraItems.forEach((element) => element.remove());
        everything = pageItems;
        if (pagination) pagination.hidden = false;
        syncPaginationLinks();
      }
      const query = input ? input.value.trim().toLowerCase() : '';
      let visible = 0;
      everything.forEach((item) => {
        const matchesSearch = !query || (item.dataset.search || '').includes(query);
        const counts = (item.dataset.playerCounts || '').split(' ');
        const matchesPlayer = !player || counts.includes(player);
        item.hidden = !(matchesSearch && matchesPlayer);
        if (!item.hidden) visible += 1;
      });
      if (countEl) countEl.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
    };

    const pageUrl = (pageNumber) => {
      const url = new URL(baseUrl, window.location.origin);
      const sort = new URLSearchParams(window.location.search).get('sort_by');
      if (sort) url.searchParams.set('sort_by', sort);
      url.searchParams.set('page', String(pageNumber));
      return url.toString();
    };

    const hrefOf = (element) => {
      const link = element.querySelector('.collection-shopping-card__image, .product-card__image');
      return link ? link.getAttribute('href') : null;
    };

    const setBusy = (busy) => {
      buttons.forEach((button) => { button.disabled = busy; });
    };

    const loadEverything = () => {
      if (loadPromise) return loadPromise;
      if (totalPages <= 1) {
        loadPromise = Promise.resolve();
        return loadPromise;
      }

      const currentPage = parseInt(grid.dataset.currentPage, 10) || 1;
      const wantedPages = [];
      for (let pageNumber = 1; pageNumber <= totalPages; pageNumber += 1) {
        if (pageNumber !== currentPage) wantedPages.push(pageNumber);
      }

      const seen = new Set(pageItems.map(hrefOf).filter(Boolean));
      const collected = new Map();
      let completed = 0;

      if (status) {
        status.hidden = false;
        status.textContent = `Loading all ${totalCount} products…`;
      }
      setBusy(true);

      const fetchPage = async (pageNumber) => {
        try {
          const response = await fetch(pageUrl(pageNumber), { headers: { 'X-Requested-With': 'fetch' } });
          if (!response.ok) return;
          const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
          collected.set(pageNumber, [...documentCopy.querySelectorAll('[data-product-item]')]);
        } catch (error) {
          return;
        } finally {
          completed += 1;
          if (status) {
            status.textContent = `Loading all ${totalCount} products… (${Math.round((completed / wantedPages.length) * 100)}%)`;
          }
        }
      };

      const queue = wantedPages.slice();
      const worker = async () => {
        while (queue.length) await fetchPage(queue.shift());
      };
      const lanes = Math.min(6, wantedPages.length);

      const finish = () => {
        if (status) status.hidden = true;
        setBusy(false);
      };

      loadPromise = Promise.all(Array.from({ length: lanes }, worker))
        .then(() => {
          [...collected.keys()].sort((a, b) => a - b).forEach((pageNumber) => {
            collected.get(pageNumber).forEach((node) => {
              const href = hrefOf(node);
              if (!href || seen.has(href)) return;
              seen.add(href);
              extraItems.push(document.importNode(node, true));
            });
          });
          finish();
        })
        .catch(finish);

      return loadPromise;
    };

    const update = async () => {
      render();
      if (hasSearch()) {
        await loadEverything();
        extraItems.forEach((element) => {
          if (!element.isConnected) grid.appendChild(element);
        });
        everything = pageItems.concat(extraItems);
      }
      render();
    };

    let debounce;
    if (input) {
      input.addEventListener('input', () => {
        clearTimeout(debounce);
        debounce = setTimeout(update, 180);
      });
    }

    buttons.forEach((button) => button.addEventListener('click', () => {
      player = button.dataset.playerFilter;
      setActiveButton();
      syncPlayerToUrl();
      update();
    }));

    setActiveButton();
    update();
  };

  document.querySelectorAll('[data-collection-tools]').forEach(init);
})();

